import type { ItineraryBlock } from '@/types/itinerary';

export function createItineraryBlockDayString(itineraryBlock: ItineraryBlock) {
  if (itineraryBlock.startDay === itineraryBlock.endDay) {
    return `Day ${itineraryBlock.startDay}`;
  }

  return `Day ${itineraryBlock.startDay} t/m ${itineraryBlock.endDay}`;
}
